import React from 'react';
import { Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const TestimonialsSection = () => {
  const featuredTestimonials = [
    { name: 'Sophie Dubois', city: 'Bruxelles', rating: 5, service: 'Retour affectif', text: 'Grâce au Maître Dia, j\'ai retrouvé l\'amour de ma vie en seulement 3 jours ! Ses résultats sont vraiment rapides et efficaces. Je recommande à 100%.' },
    { name: 'Marc Lefebvre', city: 'Anvers', rating: 5, service: 'Permis de construire', text: 'J\'attendais mon permis depuis 8 mois. Après consultation avec le Maître Dia, je l\'ai obtenu en 2 semaines ! Incroyable mais vrai.' },
    { name: 'Amina Hassan', city: 'Liège', rating: 5, service: 'Protection mauvais œil', text: 'Je subissais des malédictions et jalousie. Le Maître Dia m\'a protégée efficacement. Ma vie a complètement changé. Merci infiniment !' },
    { name: 'Jean-Pierre Martin', city: 'Gand', rating: 5, service: 'Chance aux jeux', text: 'Après 3 consultations, j\'ai gagné 15000€ au casino ! Le Maître Dia est vraiment puissant. Je suis tellement reconnaissant.' },
    { name: 'Fatima Benali', city: 'Charleroi', rating: 5, service: 'Mariage', text: 'Mon mariage était en danger. Le Maître Dia a sauvé mon couple. Maintenant nous sommes plus unis que jamais. Un grand merci !' },
    { name: 'Thomas Dupont', city: 'Bruxelles', rating: 5, service: 'Voyance', text: 'Ses prédictions sont d\'une précision incroyable. Tout ce qu\'il m\'a dit s\'est réalisé en quelques semaines. Un vrai don de clairvoyance.' },
    { name: 'Nadia Moussaoui', city: 'Namur', rating: 5, service: 'Retour affectif', text: 'Mon ex est revenu après seulement 5 jours ! Le Maître Dia est différent des autres marabouts. Résultats garantis et rapides.' },
    { name: 'Laurent Petit', city: 'Mons', rating: 5, service: 'Réussite professionnelle', text: 'J\'ai obtenu la promotion que j\'attendais depuis 2 ans grâce à lui. Ma carrière a décollé. Je recommande vivement ses services.' },
    { name: 'Yasmine Rachid', city: 'Tournai', rating: 5, service: 'Protection', text: 'Le Maître Dia m\'a protégée contre mes ennemis. Je me sens maintenant en sécurité et sereine. Sa protection est puissante.' }
  ];

  const renderStars = (rating) => {
    return (
      <div className="stars-container">
        {[...Array(5)].map((_, index) => (
          <Star
            key={index}
            size={18}
            className={index < rating ? 'star-filled' : 'star-empty'}
            fill={index < rating ? '#fbbf24' : 'none'}
          />
        ))}
      </div>
    );
  };

  return (
    <section className="testimonials-home-section">
      <div className="testimonials-home-container">
        <div className="testimonials-home-header">
          <div className="section-icon">⭐</div>
          <h2>Témoignages de Nos Clients</h2>
          <p className="testimonials-home-subtitle">
            Plus de 150 clients satisfaits témoignent de résultats rapides et efficaces
          </p>
          <div className="average-rating-home">
            <span className="rating-number-home">4.9/5</span>
            {renderStars(5)}
            <span className="rating-count">Basé sur 154 avis</span>
          </div>
        </div>

        <div className="testimonials-home-grid">
          {featuredTestimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-home-card">
              <div className="testimonial-home-header">
                <div className="testimonial-home-info">
                  <h3>{testimonial.name}</h3>
                  <p className="testimonial-home-city">{testimonial.city}</p>
                </div>
                {renderStars(testimonial.rating)}
              </div>
              <div className="testimonial-home-service">
                Service : <span>{testimonial.service}</span>
              </div>
              <p className="testimonial-home-text">{testimonial.text}</p>
            </div>
          ))}
        </div>

        <div className="testimonials-home-cta">
          <Link to="/temoignages">
            <Button className="view-all-btn">
              Voir tous les témoignages (154)
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
